var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group-append',[_c('b-button',{staticClass:"my-primary rounded-1",on:{"click":function($event){return _vm.setValueTotal(_vm.PaymentType)}}},[_vm._v(" "+_vm._s(_vm.translation.translate("frequentlyRepeated", "vsyaSumma"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }